import {FORCE_TIMELINE_RANGE_KEY} from "../../constants";

export const generateViewKey = (view, isEquipmentView, savedFilter, signeeFilter, listGroupByView, displayPreset, currentSideBarPanel, isTimelineView = "none", dateKey = "none") => {
    const viewType = isEquipmentView ? 'equipment' : 'bookings';
    const filterKey = savedFilter || 'none';
    const signeeKey = signeeFilter?.userId || 'all';

    return `${view}-${viewType}-${filterKey}-${signeeKey}-${listGroupByView}-${isTimelineView}-${dateKey}`;
};

export const resetViewState = (stateSetters, dispatchAction) => {
    const {
        setTempRowData,
        setSelectedEquipment,
        setEvents,
        setSelectedList
    } = stateSetters;

    // Clear temporary data
    if (setTempRowData) setTempRowData([]);
    if (setSelectedEquipment) setSelectedEquipment([]);
    if (setEvents) setEvents([]);
    if (setSelectedList) setSelectedList([]);

    // Clear pagination and loading states
    if (dispatchAction) {
        dispatchAction({ type: "clearAll" });
    }
};


export const shouldReloadOnViewSwitch = (currentState, previousState) => {
    if (!previousState) return true;

    return (
        currentState.view !== previousState.view ||
        currentState.isEquipmentView !== previousState.isEquipmentView ||
        currentState.savedFilter !== previousState.savedFilter ||
        currentState.signeeUserId !== previousState.signeeUserId
    );
};

export const logViewSwitch = (view, isEquipmentView, savedFilter, signeeFilter) => {
  const viewType = isEquipmentView ? 'Equipment Timeline' : 'Booking Calendar';
  const filterInfo = savedFilter ? `Filter: ${savedFilter}` : 'No filter';
  const signeeInfo = signeeFilter?.userId ? `Signee: ${signeeFilter.userId}` : 'All users';
  console.log(viewType, filterInfo, signeeInfo)
};

export const readForcedTimelineRangeFromStorage = () => {
  try {
    const raw = sessionStorage.getItem(FORCE_TIMELINE_RANGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const dateFrom = parsed?.dateFrom;
    const dateTo = parsed?.dateTo;

    if (!dateFrom || !dateTo) return null;

    return { dateFrom, dateTo };
  } catch {
    return null;
  }
};

const ViewSwitchingUtils = {
    generateViewKey,
    resetViewState,
    shouldReloadOnViewSwitch,
    logViewSwitch,
    readForcedTimelineRangeFromStorage
};

export default ViewSwitchingUtils;
